/**
 * Body styles this widget will show a tile for, in the alphabetical
 * order they should render in. The `normalBodyStyle` facet can carry values
 * outside this list, which are ignored.
 */
export const ACCEPTABLE_BODYSTYLES = [
	'Cargo Van',
	'Convertible',
	'Coupe',
	'Crossover',
	'Hatchback',
	'Luxury',
	'Sedan',
	'SUV',
	'Truck',
	'Van',
	'Wagon'
];

/**
 * The style variations the body style graphics ship in, matching the
 * `styleVariant` options in config/prefs.json. A preference value outside
 * this list has no icon to point at, so it falls back to the default.
 */
export const STYLE_VARIANTS = [
	'Thick Outline',
	'Thin Outline',
	'Thick Filled',
	'Thin Filled',
	'Thick Duotone',
	'Thin Duotone'
];

/**
 * The ws-inv-data facet that carries body styles, and the inventory search
 * parameter that filters on them.
 */
export const BODYSTYLE_FACET_ID = 'normalBodyStyle';
export const MOBILE = 'MOBILE';
/** Items per page for mobile mini-grid */
export const MOBILE_TILES_PER_PAGE = 6;
